import { Row } from "../components/Layout";
import React from "react";
import ErrorReset from "./error-reset";

const ErrorOrders = (props) => {
  return (
    <div className="container-fluid min-h-[350px]">
        <div className="pl-[15px] pr-[15px] rounded-xl mx-2 border-2 border-solid border-gray-300">
          <Row className="rounded-lg">
            <ErrorReset></ErrorReset>
          </Row>
      </div>
    </div>
  );
};

export default ErrorOrders;
